<svelte:options accessors/>
<script>
    import {createEventDispatcher, onMount} from 'svelte';
    import Search from "./Search.svelte";
    import CountryModal from "./CountryModal.svelte";

    export let pagination;
    export let tree;
    export let brands;
    export let lines;
    export let countries;

    let dispatch = createEventDispatcher();

    let filtersMobile = false;
    let categoriesMobile = false;

    export let activeGroup = null;
    let activeCat = null;
    let activeSub = null;

    let activeBrand = '';
    let activeLine = '';
    let activeCountry = '';

    let term = '';
    let activeOrder = '';

    let isActive = true;
    let searchCmp;

    onMount(() => {
        const currentParams = new URLSearchParams(window.location.search);

        activeCountry = localStorage.getItem('country') || '';
        activeCat = currentParams.get('category') || '';
        activeSub = currentParams.get('subcategory') || '';
        activeBrand = currentParams.get('brand') || '';
        activeOrder = currentParams.get('order') || '';
        term = currentParams.get('search') || '';

        disableAllTree(activeGroup, activeCat, activeSub);

        if (activeCountry) {
            isActive = false;
        }
    });

    function buildParams(term='') {
        const filters = getFilters();
        const {group} = filters;
        delete filters.group;
        const params = new URLSearchParams();
        Object.keys(filters).forEach((key) => {
            if (filters[key]) {
                params.append(key, filters[key]);
            }
        });
        const path = ['', 'productos'];
        if (group) {
            path.push(group)
        }
        return {
            url: path.join('/'),
            filters,
            params
        };
    }

    function toggleCategory(cat) {
        const {enabled} = cat;
        disableAllTree();
        cat.enabled = !enabled;
        tree = tree;
        applyFilters();
    }

    function toggleSubCategory(cat, sub) {
        const {enabled} = sub;
        disableAllTree();
        cat.enabled = true;
        sub.enabled = !enabled;
        tree = tree;
        applyFilters();
    }

    function toggleOption(cat, sub, opt) {
        const {enabled} = opt;
        disableAllTree();
        cat.enabled = true;
        sub.enabled = true;
        opt.enabled = !enabled;
        tree = tree;
        applyFilters();
    }

    function disableAllTree(acGrp = null, acCat = null, acSub = null) {
        for (const group of tree) {
            group.enabled = group.slug === acGrp;
            for (const cat of group.options) {
                cat.enabled = cat.slug === acCat;
                for (const sub of cat.options) {
                    sub.enabled = sub.slug === acSub;
                }
            }
        }
    }

    export function applyFilters() {
        dispatch('filter', buildParams());
    }

    function setCountry(ev) {
        isActive = false;
        if (ev.detail) {
            activeCountry = ev.detail;
        } else {
            activeCountry = activeCountry;
        }
        localStorage.setItem('country', activeCountry);
        applyFilters();
    }

    export function getSearchNext(page) {
        searchCmp.getPage(page);
    }

    function getFilters() {
        const selectedCat = tree.find(cat => !!cat.enabled);
        const selectedSubcat = selectedCat ? selectedCat.options.find(subCat => subCat.enabled) : null;
        const selectedOpt = selectedSubcat ? selectedSubcat.options.find(o => !!o.enabled) : null;
        return {
            group: selectedCat?.slug ?? null,
            category: selectedSubcat?.slug ?? null,
            subcategory: selectedOpt?.slug ?? null,
            brand: activeBrand ?? null,
            order: activeOrder ?? null,
            line: activeLine ?? null,
            country: activeCountry ?? null
        }
    }
</script>
<style>
    .hidden {
        display: none;
    }
</style>

<div class="boxleft">
    <div class="searchMob">
        <Search on:search on:clear bind:country={activeCountry} bind:this={searchCmp}/>
    </div>
    <div class="filtersmain" class:show={filtersMobile}>
        <div class="filterTitle" on:click="{() => filtersMobile = !filtersMobile}">
            <h2>Filtros</h2>
            <img src="/static/imgs/products/down-arrow.svg" alt="">
        </div>
        <div class="filters" class:show={filtersMobile} id="productFilter">
            <div class="filtersinner">
                <div class="search">
                    <Search on:search on:clear bind:country={activeCountry}/>
                </div>
                <div class="filterSelect">
                    <select bind:value={activeCountry} name="country" id="country" on:change={setCountry}>
                        <option value="" disabled hidden selected>País</option>
                        {#each countries as country}
                            <option value="{country.slug}">{country.name}</option>
                        {/each}
                    </select>
                </div>
                <div class="filterSelect hidden">
                    <select bind:value={activeLine} name="line" id="line" on:change={applyFilters}>
                        <option value="" disabled hidden selected>Línea</option>
                        {#each lines as line}
                            <option value="{line.slug}">{line.name}</option>
                        {/each}
                    </select>
                </div>
                <div class="filterSelect hidden">
                    <select bind:value={activeBrand} name="branch" id="branch" on:change={applyFilters}>
                        <option value="" disabled hidden selected>Marca</option>
                        {#each brands as brand}
                            <option value="{brand.slug}">{brand.name}</option>
                        {/each}
                    </select>
                </div>
                <div class="checkbox">
                    <input type="radio" name="order" id="ascendent" bind:group={activeOrder} value="{''}"
                           on:change={applyFilters}>
                    <label for="ascendent">De la A-Z</label>
                </div>
                <div class="checkbox">
                    <input type="radio" name="order" id="descendent" bind:group={activeOrder} value="{'desc'}"
                           on:change={applyFilters}>
                    <label for="descendent">De la Z-A</label>
                </div>
            </div>
            <button type="submit" form="productFilter">Filtrar</button>
        </div>
    </div>
    <div class="categories">
        <div class="categoriesinner" class:show={categoriesMobile}>
            <div class="filterTitle" on:click={() => {categoriesMobile = !categoriesMobile}}>
                <h2>Categorías</h2>
                <img src="/static/imgs/products/down-arrow.svg" alt="">
            </div>
            <div class="categorylist" class:show={categoriesMobile}>
                {#each tree as category}
                    <div class="singlecategory">
                        <div class="categorytitle" on:click="{() => toggleCategory(category)}">
                            <span>{category.name}</span>
                            <img src="/static/imgs/products/down-arrow.svg" alt="">
                        </div>
                        <div class="categoryoptions" class:show={category.enabled}>
                            {#each category.options as subcategory}
                                <div class="subcat isParent">
                                    <div class="subcat__title active"
                                         class:active={subcategory.enabled}>
                                        <a class:hasChildren={subcategory.options?.length > 0}
                                           on:click={() => toggleSubCategory(category, subcategory)}>
                                            {subcategory.name}
                                        </a>
                                        <span class="subCat__arrow"
                                              class:hasChild={subcategory.options?.length > 0}></span>
                                    </div>
                                    <ul>
                                        {#each subcategory.options as option}
                                            <li>
                                                <a class:active={option.enabled}
                                                   on:click={()=>toggleOption(category, subcategory, option)}>{option.name}</a>
                                            </li>
                                        {/each}
                                    </ul>
                                    <!--
                                    <ul>
                                        {#each subcategory.options as option}
                                            <li>
                                                <a on:click={() => filterByCategories(category, subcategory, option)}>
                                                    {option.name}
                                                </a>
                                            </li>
                                        {/each}
                                    </ul>
                                    -->
                                </div>
                            {/each}
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </div>
</div>
<CountryModal on:country={setCountry} bind:isActive={isActive} bind:countries={countries}/>